import React, { useState, useEffect } from 'react';
import $ from 'jquery';
import axios from 'axios';
import api from '../../../api/axiosInstance';
const FormMasterCalculation = ({
  formId,
  formMasterCalculations,
  onCalculationAdded,
  onCalculationDeleted,
  shouldDisableFields,
  Addcalculation
}) => {
  debugger;
  const [selectedOperandA, setSelectedOperandA] = useState('');
  const [selectedOperandB, setSelectedOperandB] = useState('');
  const [selectedOperator, setSelectedOperator] = useState('');
  const [selectedResultField, setSelectedResultField] = useState('');
  const [operandOptions, setOperandOptions] = useState([]); // Options for operands (number textboxes)
  const [loading, setLoading] = useState(false);
  const [formMasterCalculationsState, setFormMasterCalculationsState] = useState([]); // Store added calculations


  const fetchDateTypeComponents =()=>{
    api.get(`/FormMaster/GetFormMasterComponentsForCalculations?formMasterGuid=${formId}`)
    .then(response => {
      // alert("hellow");
      debugger; 
      setOperandOptions(response.data); // Set the response data directly
      
      console.log("Fetched operand options:", response.data); // Log the response to ensure data structure is correct
    })
    .catch(error => {
      console.error('Error fetching form data', error);
    })
    .finally(() => {
      setLoading(false);  // Set loading to false after the request completes
    });
  }
  // Fetch operand options on component mount
  useEffect(() => {
    setLoading(true);  // Set loading to true before making the request
    fetchDateTypeComponents();
  }, [formId]);

  const resetForm = () => {
    setSelectedOperandA('');
    setSelectedOperandB('');
    setSelectedOperator('');
    setSelectedResultField('');
  };
  // Handle changes in Operand A
  const handleOperandAChange = (e) => {
    setSelectedOperandA(e.target.value);
    setSelectedOperandB('');
    setSelectedResultField('');
  };

  // Handle changes in Operand B
  const handleOperandBChange = (e) => {
    setSelectedOperandB(e.target.value);
    setSelectedResultField('');
  };

  // Handle changes in Operator
  const handleOperatorChange = (e) => {
    setSelectedOperator(e.target.value);
  };

  // Handle changes in Result Field
  const handleResultFieldChange = (e) => {
    setSelectedResultField(e.target.value);
  };

  // Filter operands excluding selected operand (for Operand B and Result Field)
  const filterOperandOptions = (excludeOperandA, excludeOperandB) => {
    return operandOptions.filter((option) => option.id !== excludeOperandA && option.id !== excludeOperandB);
  };

  // Handle adding the calculation
  const handleAddCalculation = () => {
    if (selectedOperandA && selectedOperandB && selectedOperator && selectedResultField) {
      const newCalculation = {
        operandA: selectedOperandA,
        operandB: selectedOperandB,
        operator: selectedOperator,
        resultField: selectedResultField,
        formMasterId:formId
      };
      var formMasterCalculation = {
        "id": "3fa85f64-5717-4562-b3fc-2c963f66afa6",  // Example ID
        "name": "Calculation Name",  // Ensure this field is populated
        "formMasterId": newCalculation.formMasterId,
        "formMasterName": "Form Master Name",  // Ensure this field is populated
        "formMasterSectionId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
        "formMasterSectionName": "Form Section Name",  // Ensure this field is populated
        "operandAId": newCalculation.operandA,
        "operandAName": "Operand A Name",  // Ensure this field is populated
        "operandBId": newCalculation.operandB,
        "operandBName": "Operand B Name",  // Ensure this field is populated
        "resultId": newCalculation.resultField,
        "resultName": "Result Name",  // Ensure this field is populated
        "operatorValue": newCalculation.operator,
        "operatorText": "Operator Text"  // Ensure this field is populated
      };
      console.log(formMasterCalculation);
      onCalculationAdded(formMasterCalculation);
      console.log('Added Calculation:', formMasterCalculation);
      resetForm();
      const modal = document.getElementById('add-calculation-modal');
      modal.style.display = 'none'; // Close the modal
      const backdrop = document.querySelector('.modal-backdrop');
      if (backdrop) {
          backdrop.remove();
      }
      document.body.classList.remove('modal-open');
    } else {
      alert('Please fill in all fields');
    }
  };

  const handleDeleteCalculation = (calculationId) => {
    $.confirm({
      title: 'Confirm Deletion',
      content: 'Do you really want to delete this?',
      buttons: {
        confirm: {
          text: 'Yes',
          btnClass: 'btn-danger',
          action: () => {
            // Call the parent function to delete the calculation
            onCalculationDeleted(calculationId);
            const updatedFormMasterCalculations = formMasterCalculationsState.filter(
              (calculation) => calculation.id !== calculationId
            );
            setFormMasterCalculationsState(updatedFormMasterCalculations);
          },
        },
        cancel: {
          text: 'No',
          btnClass: 'btn-secondary',
        },
      },
    });
  };

  const handleCloseModal = () => {
    resetForm();
    const modal = document.getElementById('add-calculation-modal');
    modal.style.display = 'none'; // Close the modal
    const backdrop = document.querySelector('.modal-backdrop');
    if (backdrop) {
        backdrop.remove();
    }
  };

  return (
    <div className="card card-success mt-4">
      <div className="card-header">
        <h5>Calculations</h5>
      </div>

      <div className="card-body">
        <div className="form-group d-flex align-items-center">
          {Addcalculation && (  
          <button
            className="btn btn-success mr-2"
            data-toggle="modal"
            data-target="#add-calculation-modal"
            onClick={fetchDateTypeComponents}
            disabled={shouldDisableFields} 
          >
            Add Calculation
          </button>
          )}
        </div>

        {/* Display the added calculations */}
        <table id="calculationTable" className="table table-bordered table-striped mt-3">
          <thead>
            <tr>
              <th width="22%">Operand-A</th>
              <th width="22%">Operator</th>
              <th width="23%">Operand-B</th>
              <th width="23%">Result</th>
              <th width="10%">Action</th>
            </tr>
          </thead>
          <tbody>
          {
  formMasterCalculations && formMasterCalculations.length > 0 ? (
    formMasterCalculations.map((calculation) => (
      <tr key={calculation.id}>
        <td id={calculation.operandAId}>{calculation.operandAName}</td>
        <td id={calculation.operatorValue}>{calculation.operatorText}</td>
        <td id={calculation.operandBId}>{calculation.operandBName}</td>
        <td id={calculation.resultId}>{calculation.resultName}</td>
        <td>
          <button
            className="btn btn-xs btn-danger"
            onClick={() => handleDeleteCalculation(calculation.id)}
            title="Delete"
            disabled={shouldDisableFields} 
          >
            <i className="fa fa-trash"></i>
          </button>
        </td>
      </tr>
    ))
  ) : (
    <tr>
      <td colSpan="5" className="text-center">
        There are no calculations
      </td>
    </tr>
  )
}
          </tbody>
        </table>
      </div>

      {/* Modal for adding a new calculation */}
      <div className="modal fade" id="add-calculation-modal" tabIndex="-1" aria-labelledby="add-calculation-modal-label" aria-hidden="true">
  <div className="modal-dialog modal-dialog-centered" style={{ maxWidth: '60%' }}>
    <div className="modal-content">
      <div className="modal-header">
        <h4 className="modal-title" id="add-calculation-modal-label">Add New Calculation</h4>
        <button type="button" className="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">×</span>
        </button>
      </div>
      <div className="modal-body">
        <div className="row justify-content-start">
          {/* Operand A Dropdown */}
          <div className="col-md-6">
            <div className="form-group">
              <select className="form-control" value={selectedOperandA} onChange={handleOperandAChange}>
                <option value="">-- Select Operand A --</option>
                {
    Array.isArray(operandOptions) && operandOptions.length > 0 ? (
      operandOptions.map((option) => (
        <option key={option.id} value={option.id}>
          {option.name}
        </option>
      ))
    ) : (
      <option value="">No operands available</option>
    )
  }
              </select>
            </div>
          </div>
        </div>
        <div class="row justify-content-around">
          <div class="col-4">
          <div className="form-group">
              <select className="form-control" value={selectedOperator} onChange={handleOperatorChange}>
                <option value="">-- Select Operator --</option>
                <option value="121440000">Add (+)</option>
                <option value="121440001">Subtract (-)</option>
                <option value="121440002">Multiply (*)</option>
                <option value="121440003">Divide (/)</option>
              </select>
            </div>
          </div>
          <div class="col-4">
          <div className="form-group">
              <select className="form-control" value={selectedResultField} onChange={handleResultFieldChange} disabled={!selectedOperandA || !selectedOperandB}>
                <option value="">-- Select Result Field --</option>
                {selectedOperandA && selectedOperandB && filterOperandOptions(selectedOperandA, selectedOperandB).map((option) => (
                  <option key={option.id} value={option.id}>
                    {option.name}
                  </option>
                ))}
              </select>
            </div>
          </div>
        </div>
             
          <div className="row">
          {/* Operand B Dropdown */}
          <div className="col-md-6">
            <div className="form-group">
              <select className="form-control" value={selectedOperandB} onChange={handleOperandBChange} disabled={!selectedOperandA}>
                <option value="">-- Select Operand B --</option>
                {selectedOperandA && filterOperandOptions(selectedOperandA, '').map((option) => (
                  <option key={option.id} value={option.id}>
                    {option.name}
                  </option>
                ))}
              </select>
            </div>
          </div>
        </div>
      </div>
      <div className="modal-footer justify-content-between">
        <button type="button" className="btn btn-default" data-dismiss="modal" onClick={handleCloseModal}>Close</button>
        <button type="button" className="btn btn-primary" onClick={handleAddCalculation}>Save Calculation</button>
      </div>
    </div>
  </div>
</div>

    </div>
  );
};

export default FormMasterCalculation;
